<template>
    <div class="section">

        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns is-multiline">
            <div class="column is-full">
                <h1 class="title is-size-2">
                    {{contact.title}}
                    <span class="tag m-l-5" :class="contact.contactType == 'L' ? 'is-success' : 'is-info'">{{contact.getContactTypeDisplay}} </span>
                </h1>
            </div>

            <div class="column is-half">
                <p>{{ new Date(contact.timestamp).toLocaleDateString() }}</p>
                <p>{{contact.emailDisplay}} <span v-if="contact.phoneNumber">-</span> {{ contact.phoneNumber}}</p>
            </div>
            <div class="column is-half has-text-centered">
                <p><span v-if="contact.productObj.title" class="has-text-weight-bold"> Interesado en:</span> {{contact.productObj.title}}</p>
                <img style="max-width:200px" :src="contact.productObj.getImage" alt="">
            </div>

            <hr>

            <div class="column is-full">
                <p class="has-text-weight-bold">Mensaje:</p>
                <p>{{contact.message}}</p>
            </div>
        </div>

    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
export default {
    props:{
        detailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:true,
            contact:{},
        }
    },
    methods:{
        async fetchContact(){
            this.loading = true
            this.contact = await getHandler(this.detailUrl, {error:false, success:false})
            console.log(this.contact)
            this.loading = false
        }
    },
    created(){
        this.fetchContact()
    }
}
</script>